import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledContainer = styled.p`
  display: flex;
  margin: 2rem 0;

  > button {
    margin: 0.5rem;

    &:first-of-type {
      margin-left: 0;
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
`;

const DownloadLinks = props => {
  const { children } = props;
  return (
    <StyledContainer>{children}</StyledContainer>
  );
}

DownloadLinks.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
}

export default DownloadLinks;


// WEBPACK FOOTER //
// ./src/modules/pages/components/DownloadLinks.js